import Router from "vue-router"
import Vue from "vue"
Vue.use(Router)

const createRouter=()=>new Router({
    mode:"hash",
    routes:[
        {
          path: "/", // 首页
          name: "home",
          component: () => import("@/views/home/index.vue")
        },
        {
           path: "/tianqin", // 天琴
           name: "tianqin",
           component: () => import("@/views/tianqin/index.vue")
        },
        {
           path: "/tianqin-promoter", // 天琴-高登
           name: "tianqinpromoter",
           component: () => import("@/views/tianqinpromoter/index.vue")
        },
        {
           path: "/sheshou", // 射手
           name: "sheshou",
           component: () => import("@/views/sheshou/index.vue")
         }, 
         {
           path: "/linyuan", // 临渊
           name: "linyuan",
           component: () => import("@/views/linyuan/index.vue")
         },
         {
           path: "/xianhou", // xianhou
           name: "xianhou",
           component: () => import("@/views/xianhou/index.vue")
         },
         {
           path: "/taitan", // 泰坦
           name: "taitan",
           component: () => import("@/views/taitan/index.vue")
         },
         {
           path: "/interface", // 接口
           name: "interface",
           component: () => import("@/views/interface/index.vue")
         },
        {
            path: "/contact", // 联系我们
            name: "contact",
            component: () => import("@/views/contact/index.vue")
         },
         {
           path: "/login", // 天琴
           name: "login",
           component: () => import("@/views/login/index.vue")
         },
         {
          path: "/xingchenpinyue-partner", // 星辰品阅
          name: "xcpinyuepartner",
          component: () => import("@/views/xcpinyuepartner/index.vue")
         },
        // {
        //   path: "/newsList", // 新闻列表
        //   name: "newsList",
        //   component: () => import("@/views/news/index.vue")
        // },
        // {
        //   path: "/newsDetail/:id", // 新闻详情
        //   name: "newsDetail",
        //   component: () => import("@/views/news/Detail.vue")
        // },
        
        // {
        //   path: "/about", // 公司简介
        //   name: "about",
        //   component: () => import("@/views/about/index.vue")
        // },
        // {
        //   path: "/ss", // 射手
        //   name: "sheshou",
        //   component: () => import("@/views/sheshou/index.vue")
        // },
        // {
        //   path: "/qfy", // 千帆云
        //   name: "qianfanyun",
        //   component: () => import("@/views/qianfanyun/index.vue")
        // }
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    }
})

export  {createRouter};
